import { render, staticRenderFns } from "./DocumentDraftingCreate.vue?vue&type=template&id=3019aab8&scoped=true"
import script from "./DocumentDraftingCreate.vue?vue&type=script&lang=js"
export * from "./DocumentDraftingCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentDraftingCreate.vue?vue&type=style&index=0&id=3019aab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019aab8",
  null
  
)

export default component.exports